import script from "./MypageMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MypageMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MypageMenu.vue?vue&type=style&index=0&id=7f04d36b&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f04d36b"]])

export default __exports__